angular.module('SpidApp')

.factory('StickerPrinter',
        ['$http', 'SPID_CONFIG', '$q',
function ($http,   SPID_CONFIG,   $q) {
	var CONFIG = SPID_CONFIG.devices.stickerPrinter

	var HOST = CONFIG.host
	var PORT = CONFIG.port

	var IS_MOCKED = CONFIG.isMocked
	
	var StickerPrinter = {
		getStatus: (IS_MOCKED ? function () {
			return $q(function (resolve) { resolve() })
		} : function () {
			return $http.get(HOST + ':' + PORT + '/stickerPrinter/status').then(function (response) {
				return $q(function (resolve) {
					resolve(response.data)
				})
			})
		}),
		printSticker: function (data, quantity) {
			return $http.post(HOST + ':' + PORT + '/impVignette', { pdfToPrint: data, quantity : quantity }).then(function (response) {
				return $q(function (resolve, reject) {
					if (response.data === 'received') {
						resolve(response.data)
					}
					reject(response.data)
				})
			})
		}
	}

	return StickerPrinter
}])